import BaseEntity from '../BaseEntity.model';

export default interface IAbuseHistoryItem extends BaseEntity {
    Label: string;
    Details: string;
    Tcode: string;
    TcodeDescription: string;
    Zcode: string;
    ZcodeDescription: string;
}

export class AbuseHistoryItem implements IAbuseHistoryItem {
    Id: string;
    Label: string;
    Details: string;
    Tcode: string;
    TcodeDescription: string;
    Zcode: string;
    ZcodeDescription: string;

    constructor() {
        this.Id = '';
        this.Label = '';
        this.Details = '';
        this.Tcode = '';
        this.TcodeDescription = '';
        this.Zcode = '';
        this.ZcodeDescription = '';
    }
}
